import { usePathname } from 'expo-router';

import { useLocaleLinks } from '@todo/core/i18n/locale-links-context';
import type { Locale } from '@todo/core/i18n/locales';
import { withLocale } from '@todo/core/i18n/use-locale';

/**
 * The language links' targets (header and footer): this page under another
 * locale prefix, or — on a page whose URL differs per language (a guide: one
 * slug per version) — where its LocaleLinksProvider says that version is.
 */
export function useLanguageHref(): (locale: Locale) => string {
  const pathname = usePathname();
  const links = useLocaleLinks();
  return (locale) => (links?.[locale] as string | undefined) ?? withLocale(pathname, locale);
}
